import React, {
  forwardRef,
  DetailedHTMLProps,
  InputHTMLAttributes,
  useState,
} from "react";
import classNames from "classnames";
import HidePasswordIcon from "Assets/Icons/HidePasswordIcon";
import EyeIcon from "Assets/Icons/EyeIcon";

export type InputSize = "medium" | "large";
export type InputType = "text" | "email" | "password" | "number";

export type InputProps = {
  id: string;
  name: string;
  value?: any;
  label?: string;
  type?: InputType;
  size?: InputSize;
  className?: string;
  placeholder?: string;
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "size"
>;

const sizeMap: { [key in InputSize]: string } = {
  medium: "p-3 text-base",
  large: "p-4 text-base",
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      id,
      name,
      value,
      label,
      type = "text",
      size = "medium",
      className = "",
      placeholder,
      ...props
    },
    ref
  ): JSX.Element => {
    const [viewPassword, setViewPassword] = useState<boolean>(false);
    const handleOnInternalBtnClick = () => {
      setViewPassword(!viewPassword);
    };
    return (
      <React.Fragment>
        <label htmlFor={id} className="form-label">
          {label}
        </label>
        <div className="position-relative">
          <input
            id={id}
            ref={ref}
            name={name}
            value={value}
            type={viewPassword ? "text" : type}
            aria-label={label}
            placeholder={placeholder}
            className={classNames([
              "form-control simple-input relative inline-flex w-full",
              sizeMap[size],
              className,
            ])}
            {...props}
          />
          {type === "password" ? (
            <div
              className="position-absolute  right-2 top-2 h-full my-auto pointer-events-auto flex items-center"
              onClick={handleOnInternalBtnClick}
            >
              {viewPassword ? (
                <HidePasswordIcon className="cursor-pointer" />
              ) : (
                <EyeIcon className="cursor-pointer" />
              )}
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
);
Input.displayName = "Input";
export { Input };
